import { arbitrum as viemArbitrum } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const arbitrum = {
  displayName: 'Arbitrum',
  runtime: 'evm',
  viemChain: viemArbitrum,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 4,

  decoration: {
    color: '#9DCCED',
    contrastColor: getContrastColor('#9DCCED'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'arbitrum-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://arbiscan.io',
        token: 'https://arbiscan.io/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    cowSwap: { chainKey: 'arbitrum_one', blockExplorerKey: '/arb1' },
    debridge: {
      chainKey: '42161',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    lifi: { chainKey: 'ARB' },
    stargate: { chainKey: 'arbitrum' },
    across: { chainKey: 'arbitrum' },
    xswap: { chainKey: '42161' },
    renegade: { chainKey: 'arbitrum' },
    okx: { chainKey: '42161' },
    kyberswap: { chainKey: 'arbitrum' },
    houdini: { chainKey: 'ARB' },
  }),
  services: defaultServices({
    codex: {
      networkId: 42161,
      nativeLiquidityAddress: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    },
    coingecko: {
      networkId: 'arbitrum',
      platformId: 'arbitrum-one',
    },
    coingeckoDex: {
      networkId: 'arbitrum',
    },
    defiLlama: { chainKeys: ['arbitrum'] },
    trm: { chainKey: 'arbitrum' },
    zerion: { chainKey: 'arbitrum' },
    qnStreams: {
      networkKey: 'arbitrum-mainnet',
    },
    safe: { shortName: 'arb1' },
    alchemy: { chainSlug: 'arb-mainnet' },
    pimlico: { chainSlug: 'arbitrum' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
